import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { API_BASE_URL } from './config/api_keys';

function GoogleSignIn() {
 
 const responseMessage = (response) => {
    // console.log(response);
   axios.post(`${API_BASE_URL}/google-auth`, {
     credential: response.credential,
   })
   .then(response => {
     // Handle the response from the server
    //  console.log(response.data.token);
     localStorage.setItem('authToken', response.data.token);
     localStorage.setItem('authemail', response.data.email);
     localStorage.setItem('authname', response.data.name);
     localStorage.setItem('authphone', response.data.phone);
     localStorage.setItem('authpicture', response.data.picture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png");
     localStorage.setItem('userId', response.data.userId); // Store userId
     window.location.href = '/';
   })
   .catch(error => {
     console.log(error);
   });
 };
 
 const errorMessage = (error) => {
   console.log(error);
 };
    return (
        <div>
            <GoogleLogin onSuccess={responseMessage} onError={errorMessage} />
        </div>
    )
}
export default GoogleSignIn;